import { parse } from "../utils";

export default {
  "get|library/GetTrendList": (option) => {
    let list = [
      {
        id: "1",
        title: "ビックデータ",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-22 09:12:08",
        category: "",
        belongYear: 0,
      },
      {
        id: "2",
        title: "医療崩壊",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-06-22 09:12:08",
        category: "",
        belongYear: 0,
      },
      {
        id: "3",
        title: "人工知能（AI）",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: "",
        belongYear: 0,
      },
      {
        id: "4",
        title: "デジタル地域通貨",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: "",
        belongYear: 0,
      },
    ];

    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/GetNriReportList": (option) => {
    let list = [
      {
        id: "1",
        title:
          "ビックデータ1ビックデータビックデータビックデータビックデータビックデータ",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-06-22 09:12:08",
        belongYear: 0,
        sortNo: 1,
      },
      {
        id: "2",
        title: "医療崩壊2",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-06-22 09:12:08",
        belongYear: 0,
        sortNo: 2,
      },
      {
        id: "3",
        title: "人工知能（AI）3",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        belongYear: 0,
        sortNo: 3,
      },
      {
        id: "4",
        title: "デジタル地域通貨4",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        belongYear: 0,
        sortNo: 4,
      },
    ];

    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/Getpdfcategory": (option) => {
    const pagename = parse("pagename", option.url);
    let list = [
      {
        itemid: "ca8f6388-8d3a-4248-9cd3-dc8b96b53202",
        categoryName: "事業承継全般",
        categoryDesc: "事業承継全般",
        sortNo: 1,
      },
      {
        itemid: "41f94160-74b9-4eae-90cf-df3cdd8a2f0a",
        categoryName: "自社株式（評価方法）",
        categoryDesc: "自社株式（評価方法）",
        sortNo: 2,
      },
      {
        itemid: "9669c06c-63cd-4c6d-a3b1-3039d4963843",
        categoryName: "自社株式（売買・贈与）",
        categoryDesc: "自社株式（売買・贈与）",
        sortNo: 3,
      },
      {
        itemid: "1fe33dcd-be05-41ff-a818-04aa22d98cd0",
        categoryName: "納税猶予制度",
        categoryDesc: "納税猶予制度",
        sortNo: 4,
      },
      {
        itemid: "349e58b0-9604-4682-b890-4a1e787a6b51",
        categoryName: "退職金",
        categoryDesc: "退職金",
        sortNo: 5,
      },
      {
        itemid: "ebd3e986-9876-4142-8222-7d660f9c9a5a",
        categoryName: "資産管理会社",
        categoryDesc: "資産管理会社",
        sortNo: 6,
      },
      {
        itemid: "c01ba24c-57a4-48ff-b6b3-575f7ba18cfb",
        categoryName: "資本金",
        categoryDesc: "資本金",
        sortNo: 7,
      },
      {
        itemid: "8bb0a85e-f187-42d4-b042-7c84be465c7a",
        categoryName: "定款",
        categoryDesc: "定款",
        sortNo: 8,
      },
      {
        itemid: "8bb0a85e-f187-42d4-b042-7c84be465c71",
        categoryName: "財団・社団・持株会",
        categoryDesc: "財団・社団・持株会",
        sortNo: 9,
      },
      {
        itemid: "66aa12dd-a227-4db3-a89f-4dabc1751aa4",
        categoryName: "議決権比率・持株比率",
        categoryDesc: "議決権比率・持株比率",
        sortNo: 10,
      },
      {
        itemid: "60f69d66-abdd-4013-8a3b-05bd25dd77e7",
        categoryName: "相続全般（環境）",
        categoryDesc: "相続全般（環境）",
        sortNo: 11,
      },
      {
        itemid: "726a53a7-94c0-436a-b545-29888f2cc540",
        categoryName: "相続全般（相続・贈与）",
        categoryDesc: "相続全般（相続・贈与）",
        sortNo: 12,
      },
      {
        itemid: "bfe345ac-14b1-44a9-9c1d-49c2a5756688",
        categoryName: "相続全般（遺産分割）",
        categoryDesc: "相続全般（遺産分割）",
        sortNo: 13,
      },
      {
        itemid: "d3f26ee4-8cfe-418d-86c8-08982b38506c",
        categoryName: "相続全般（不動産）",
        categoryDesc: "相続全般（不動産）",
        sortNo: 14,
      },
      {
        itemid: "8e8cb411-049d-4e9a-a588-0381188e26a1",
        categoryName: "税制改正",
        categoryDesc: "税制改正",
        sortNo: 15,
      },
    ];
    if (pagename === "ipo") {
      list = [
        {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
          sortNo: 1,
        },
        {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
          sortNo: 2,
        },
        {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
          sortNo: 3,
        },
      ];
    }

    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/GetTaxaList": (option) => {
    let list = [
      {
        id: "3",
        title: "未上場株式の評価方法",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "41f94160-74b9-4eae-90cf-df3cdd8a2f0a",
          categoryName: "自社株式（評価方法）",
          categoryDesc: "自社株式（評価方法）",
        },
        belongYear: 0,
      },
      {
        id: "1",
        title: "最近の事業承継",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f6388-8d3a-4248-9cd3-dc8b96b53202",
          categoryName: "事業承継全般",
          categoryDesc: "事業承継全般",
        },
        belongYear: 0,
      },
      {
        id: "5",
        title: "譲渡と贈与の比較",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "9669c06c-63cd-4c6d-a3b1-3039d4963843",
          categoryName: "自社株式（売買・贈与）",
          categoryDesc: "自社株式（売買・贈与）",
        },
        belongYear: 0,
      },
      {
        id: "2",
        title: "非上場企業の事業承継対策",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f6388-8d3a-4248-9cd3-dc8b96b53202",
          categoryName: "事業承継全般",
          categoryDesc: "事業承継全般",
        },
        belongYear: 0,
      },

      {
        id: "4",
        title: "自社株式評価の増減要素",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "41f94160-74b9-4eae-90cf-df3cdd8a2f0a",
          categoryName: "自社株式（評価方法）",
          categoryDesc: "自社株式（評価方法）",
        },
        belongYear: 0,
      },

      {
        id: "6",
        title: "発行会社による自社株買い（みなし配当課税）",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "9669c06c-63cd-4c6d-a3b1-3039d4963843",
          categoryName: "自社株式（売買・贈与）",
          categoryDesc: "自社株式（売買・贈与）",
        },
        belongYear: 0,
      },
      {
        id: "7",
        title: "法人向け納税猶予制度",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "1fe33dcd-be05-41ff-a818-04aa22d98cd0",
          categoryName: "納税猶予制度",
          categoryDesc: "納税猶予制度",
        },
        belongYear: 0,
      },
      {
        id: "8",
        title: "個人事業者向け納税猶予制度",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "1fe33dcd-be05-41ff-a818-04aa22d98cd0",
          categoryName: "納税猶予制度",
          categoryDesc: "納税猶予制度",
        },
        belongYear: 0,
      },
      {
        id: "9",
        title: "退職金の基礎知識",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "349e58b0-9604-4682-b890-4a1e787a6b51",
          categoryName: "退職金",
          categoryDesc: "退職金",
        },
        belongYear: 0,
      },
      {
        id: "10",
        title: "資産管理会社の活用",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "ebd3e986-9876-4142-8222-7d660f9c9a5a",
          categoryName: "資産管理会社",
          categoryDesc: "資産管理会社",
        },
        belongYear: 0,
      },
      {
        id: "11",
        title: "含み益に対する37%控除",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "ebd3e986-9876-4142-8222-7d660f9c9a5a",
          categoryName: "資産管理会社",
          categoryDesc: "資産管理会社",
        },
        belongYear: 0,
      },
      {
        id: "12",
        title: "設立方法",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "ebd3e986-9876-4142-8222-7d660f9c9a5a",
          categoryName: "資産管理会社",
          categoryDesc: "資産管理会社",
        },
        belongYear: 0,
      },
      {
        id: "13",
        title: "資本金の多寡及び無償原資",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "c01ba24c-57a4-48ff-b6b3-575f7ba18cfb",
          categoryName: "資本金",
          categoryDesc: "資本金",
        },
        belongYear: 0,
      },
      {
        id: "14",
        title: "減資について",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "c01ba24c-57a4-48ff-b6b3-575f7ba18cfb",
          categoryName: "資本金",
          categoryDesc: "資本金",
        },
        belongYear: 0,
      },
      {
        id: "15",
        title: "定款について",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "8bb0a85e-f187-42d4-b042-7c84be465c7a",
          categoryName: "定款",
          categoryDesc: "定款",
        },
        belongYear: 0,
      },
      {
        id: "16",
        title: "財団・社団の概要",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "8bb0a85e-f187-42d4-b042-7c84be465c71",
          categoryName: "財団・社団・持株会",
          categoryDesc: "財団・社団・持株会",
        },
        belongYear: 0,
      },
      {
        id: "17",
        title: "株主総会決議事項等",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "66aa12dd-a227-4db3-a89f-4dabc1751aa4",
          categoryName: "議決権比率・持株比率",
          categoryDesc: "議決権比率・持株比率",
        },
        belongYear: 0,
      },
      {
        id: "18",
        title: "議決権の集約方法",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "66aa12dd-a227-4db3-a89f-4dabc1751aa4",
          categoryName: "議決権比率・持株比率",
          categoryDesc: "議決権比率・持株比率",
        },
        belongYear: 0,
      },
      {
        id: "19",
        title: "富裕層を取り巻く環境及び相続について",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "60f69d66-abdd-4013-8a3b-05bd25dd77e7",
          categoryName: "相続全般（環境）",
          categoryDesc: "相続全般（環境）",
        },
        belongYear: 0,
      },
      {
        id: "20",
        title: "相続税の計算の仕組み",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "726a53a7-94c0-436a-b545-29888f2cc540",
          categoryName: "相続全般（相続・贈与）",
          categoryDesc: "相続全般（相続・贈与）",
        },
        belongYear: 0,
      },
      {
        id: "21",
        title: "相続税・贈与税の速算表・早見表",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "726a53a7-94c0-436a-b545-29888f2cc540",
          categoryName: "相続全般（相続・贈与）",
          categoryDesc: "相続全般（相続・贈与）",
        },
        belongYear: 0,
      },
      {
        id: "22",
        title: "相続人の範囲",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "bfe345ac-14b1-44a9-9c1d-49c2a5756688",
          categoryName: "相続全般（遺産分割）",
          categoryDesc: "相続全般（遺産分割）",
        },
        belongYear: 0,
      },
      {
        id: "23",
        title: "遺言と遺留分及び改正点",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "bfe345ac-14b1-44a9-9c1d-49c2a5756688",
          categoryName: "相続全般（遺産分割）",
          categoryDesc: "相続全般（遺産分割）",
        },
        belongYear: 0,
      },
      {
        id: "24",
        title: "評価方法と小規模宅地等の特例適用時のイメージ",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "d3f26ee4-8cfe-418d-86c8-08982b38506c",
          categoryName: "相続全般（不動産）",
          categoryDesc: "相続全般（不動産）",
        },
        belongYear: 0,
      },
      {
        id: "25",
        title: "生産緑地2022年（所有者）",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "d3f26ee4-8cfe-418d-86c8-08982b38506c",
          categoryName: "相続全般（不動産）",
          categoryDesc: "相続全般（不動産）",
        },
        belongYear: 0,
      },
      {
        id: "26",
        title: "相続人の範囲",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "8e8cb411-049d-4e9a-a588-0381188e26a1",
          categoryName: "税制改正",
          categoryDesc: "税制改正",
        },
        belongYear: 0,
      },
      {
        id: "27",
        title: "令和3年度税制改正大綱ポイント解説",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "8e8cb411-049d-4e9a-a588-0381188e26a1",
          categoryName: "税制改正",
          categoryDesc: "税制改正",
        },
        belongYear: 0,
      },
      {
        id: "28",
        title: "（法人向け）令和3年度税制改正の影響と納税猶予制度について",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "8e8cb411-049d-4e9a-a588-0381188e26a1",
          categoryName: "税制改正",
          categoryDesc: "税制改正",
        },
        belongYear: 0,
      },
      {
        id: "29",
        title: "（個人向け）令和3年度税制改正の影響と相続対策",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "8e8cb411-049d-4e9a-a588-0381188e26a1",
          categoryName: "税制改正",
          categoryDesc: "税制改正",
        },
        belongYear: 0,
      },
    ];
    
    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/GetBusinessReportList": (option) => {
    let list = [
      {
        id: "1",
        title: "業界レポート①",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "41f94160-74b9-4eae-90cf-df3cdd8a2f0a",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },
      {
        id: "2",
        title: "業界レポート②",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f6388-8d3a-4248-9cd3-dc8b96b53202",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },
      {
        id: "3",
        title: "業界レポート③",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "9669c06c-63cd-4c6d-a3b1-3039d4963843",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },
      {
        id: "4",
        title: "業界レポート④",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f6388-8d3a-4248-9cd3-dc8b96b53202",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },

      {
        id: "5",
        title: "業界レポート⑤",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "41f94160-74b9-4eae-90cf-df3cdd8a2f0a",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },

      {
        id: "6",
        title: "業界レポート⑥",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "9669c06c-63cd-4c6d-a3b1-3039d4963843",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },
      {
        id: "7",
        title: "業界レポート⑦",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "1fe33dcd-be05-41ff-a818-04aa22d98cd0",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },
      {
        id: "8",
        title: "業界レポート⑧",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "1fe33dcd-be05-41ff-a818-04aa22d98cd0",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },
      {
        id: "9",
        title: "業界レポート⑨",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "349e58b0-9604-4682-b890-4a1e787a6b51",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },
      {
        id: "10",
        title: "業界レポート⑩",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-26 09:12:08",
        createDate: "2021-06-25 09:12:08",
        category: {
          itemid: "ebd3e986-9876-4142-8222-7d660f9c9a5a",
          categoryName: "フード&アグリビジネス",
          categoryDesc: "フード&アグリビジネス",
        },
        belongYear: 0,
      },
    ];

    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/GetIpoList": (option) => {
    let list = [
      {
        id: "1",
        title: "全章",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
        },
        belongYear: 0,
      },
      {
        id: "2",
        title: "第1章 上場制度の概要",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
        },
        belongYear: 0,
      },
      {
        id: "3",
        title: "第2章 上場準備の外部関係者と上場のスケジュール",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
        },
        belongYear: 0,
      },
      {
        id: "4",
        title: "第3章 上場審査基準と上場審査の内容",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
        },
        belongYear: 0,
      },
      {
        id: "5",
        title: "第4章 タイトルが入ります",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
        },
        belongYear: 0,
      },
      {
        id: "6",
        title: "第5章 タイトルが入ります",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
        },
        belongYear: 0,
      },
      {
        id: "7",
        title: "第6章 タイトルが入ります",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
        },
        belongYear: 0,
      },
      {
        id: "8",
        title: "第7章 タイトルが入ります",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f633",
          categoryName: "IPOの手引き『株式公開読本』",
          categoryDesc: "IPOの手引き『株式公開読本』",
        },
        belongYear: 0,
      },
    ];
    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/GetIpoYearList": (option) => {
    let list = [
      {
        id: "2",
        title: "2020年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "1",
        title: "2021年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "3",
        title: "2019年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "4",
        title: "2018年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "5",
        title: "2017年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "6",
        title: "2016年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "7",
        title: "2015年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "8",
        title: "2014年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "9",
        title: "2013年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
      {
        id: "10",
        title: "2012年",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f632",
          categoryName: "IPO年次データ集",
          categoryDesc: "IPO年次データ集",
        },
        belongYear: 0,
      },
    ];
    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/GetIpoMonthList": (option) => {
    let list = [
      {
        id: "2",
        title: "11月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "1",
        title: "12月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "4",
        title: "09月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "3",
        title: "10月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "5",
        title: "08月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "6",
        title: "07月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "7",
        title: "06月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "8",
        title: "05月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "9",
        title: "04月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "10",
        title: "03月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "14",
        title: "1月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2021,
      },
      {
        id: "11",
        title: "02月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "12",
        title: "01月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-24 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2020,
      },
      {
        id: "13",
        title: "2月号",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-22 09:12:08",
        category: {
          itemid: "ca8f631",
          categoryName: "IPOマンスリートピックス",
          categoryDesc: "IPOマンスリートピックス",
        },
        belongYear: 2021,
      },
    ];
    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/GetMAList": (option) => {
    let list = [
      {
        id: "1",
        title: "医療機器卸売",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-05-22 09:12:08",
        category: "",
        belongYear: 0,
      },
      {
        id: "2",
        title: "介護",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-06-23 09:12:08",
        createDate: "2021-05-22 09:12:08",
        category: "",
        belongYear: 0,
      },
      {
        id: "3",
        title: "建設",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-03-24 09:12:08",
        category: "",
        belongYear: 0,
      },
      {
        id: "4",
        title: "ソフトウェア",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: "2021-02-26 09:12:08",
        createDate: "2021-01-25 09:12:08",
        category: "",
        belongYear: 0,
      },
    ];

    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "get|library/GetFinancialAnalysisTipsList": (option) => {
    let list = [
      {
        id: "4986f3dc-6902-4f78-8c59-5b43fede9e94",
        title: "キャッシュフローの状況が示す企業のあり姿",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-07-29T00:00:00+09:00",
        category: {
          itemid: "cf7241b2-c71d-4ea7-b7db-9f9b67ebaa03",
          categoryName: "キャッシュフローと会社資産構造に関する解説",
          categoryDesc: "キャッシュフローと会社資産構造に関する解説",
          sortNo: 3,
        },
        target: "_blank",
        libraryType: "pdf",
        linkUrl: null,
      },
      {
        id: "737bc8d8-5d6e-4059-980c-6be2f4394bea",
        title: "売上原価の比率が高い場合",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-08T00:00:00+09:00",
        category: {
          itemid: "6551d2df-82b0-49e7-81eb-c645c1850d2e",
          categoryName: "費用構造と生産性に関する解説",
          categoryDesc: "費用構造と生産性に関する解説",
          sortNo: 2,
        },
        target: "",
        libraryType: "pdf",
        linkUrl: null,
      },
      {
        id: "0fcf5b36-cfe1-48f3-8f6c-485539616ad7",
        title: "販売費・一般管理費の比率が高い場合",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-08T00:00:00+09:00",
        category: {
          itemid: "6551d2df-82b0-49e7-81eb-c645c1850d2e",
          categoryName: "費用構造と生産性に関する解説",
          categoryDesc: "費用構造と生産性に関する解説",
          sortNo: 2,
        },
        target: null,
        libraryType: "pdf",
        linkUrl: null,
      },
      {
        id: "a629ecf8-8434-4e60-8027-15576b00b614",
        title: "会社資産構造の同業他社との比較方法",
        pdfFile: null,
        updateDate: "2021-07-28T00:00:00+09:00",
        createDate: "2021-07-21T09:00:00+09:00",
        category: {
          itemid: "7cccab21-6bf6-49a2-bd0c-aa94edf3e478",
          categoryName: "経営指標の解説",
          categoryDesc: "経営指標の解説",
          sortNo: 1,
        },
        target: "_self",
        libraryType: "link",
        linkUrl: "https://www.yahoo.co.jp/",
      },
      {
        id: "d0fbdb7a-dcdf-411f-9bbf-e80f18134278",
        title: "キャッシュフローと会社資産構造（貸借対照表）の関係",
        pdfFile: null,
        updateDate: "2021-07-28T00:00:00+09:00",
        createDate: "2021-07-21T09:00:00+09:00",
        category: {
          itemid: "cf7241b2-c71d-4ea7-b7db-9f9b67ebaa03",
          categoryName: "キャッシュフローと会社資産構造に関する解説",
          categoryDesc: "キャッシュフローと会社資産構造に関する解説",
          sortNo: 3,
        },
        target: "_blank",
        libraryType: "link",
        linkUrl: "https://www.yahoo.co.jp/",
      },
      {
        id: "f51e2cbf-cf7f-4081-8743-c4b667c3218e",
        title: "会社資産構造の同業他社との比較方法",
        pdfFile: null,
        updateDate: "2021-07-29T00:00:00+09:00",
        createDate: "2021-07-21T09:00:00+09:00",
        category: {
          itemid: "cf7241b2-c71d-4ea7-b7db-9f9b67ebaa03",
          categoryName: "キャッシュフローと会社資産構造に関する解説",
          categoryDesc: "キャッシュフローと会社資産構造に関する解説",
          sortNo: 3,
        },
        target: "_blank",
        libraryType: "link",
        linkUrl: "https://www.baidu.com",
      },
      {
        id: "b6bd43e7-b092-4dd4-b275-22e82dc8932b",
        title: "費用構造と生産性の関係",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-08T00:00:00+09:00",
        category: {
          itemid: "6551d2df-82b0-49e7-81eb-c645c1850d2e",
          categoryName: "費用構造と生産性に関する解説",
          categoryDesc: "費用構造と生産性に関する解説",
          sortNo: 2,
        },
        target: "_blank",
        libraryType: "pdf",
        linkUrl: null,
      },
      {
        id: "208481e8-c1d0-42a6-9cdd-0b34b2e709d0",
        title: "売上高成長率",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-08T00:00:00+09:00",
        category: {
          itemid: "7cccab21-6bf6-49a2-bd0c-aa94edf3e478",
          categoryName: "経営指標の解説",
          categoryDesc: "経営指標の解説",
          sortNo: 1,
        },
        target: "_blank",
        libraryType: "pdf",
        linkUrl: null,
      },
      {
        id: "335c1f99-02fe-4ead-adf0-d8b9df32d1cb",
        title: "売上高総利益率",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-08T00:00:00+09:00",
        category: {
          itemid: "7cccab21-6bf6-49a2-bd0c-aa94edf3e478",
          categoryName: "経営指標の解説",
          categoryDesc: "経営指標の解説",
          sortNo: 1,
        },
        target: "_blank",
        libraryType: "pdf",
        linkUrl: null,
      },
      {
        id: "a1662ccf-eee2-4e30-b5c0-ed663f7ede7c",
        title: "固定長期適合率",
        pdfFile: null,
        updateDate: null,
        createDate: "2021-07-21T09:00:00+09:00",
        category: {
          itemid: "7cccab21-6bf6-49a2-bd0c-aa94edf3e478",
          categoryName: "経営指標の解説",
          categoryDesc: "経営指標の解説",
          sortNo: 1,
        },
        target: "_blank",
        libraryType: "link",
        linkUrl: "http://www.baidu.com",
      },
      {
        id: "d3b2bb3b-e47d-4c4d-8795-33710f560fdd",
        title: "有形固定資産回転率",
        pdfFile: require("@/assets/images/temp.pdf"),
        updateDate: null,
        createDate: "2021-06-08T00:00:00+09:00",
        category: {
          itemid: "7cccab21-6bf6-49a2-bd0c-aa94edf3e478",
          categoryName: "経営指標の解説",
          categoryDesc: "経営指標の解説",
          sortNo: 1,
        },
        target: "_blank",
        libraryType: "pdf",
        linkUrl: null,
      },
    ];
    return {
      code: 200,
      msg: "操作成功",
      data: list,
    };
  },
  "post|library/GetList": (option) => {
    const pageSize = parse("pagesize", option.url);
    let list = [];
    if (pageSize > 4) {
      list = [
        {
          cover: require("@/assets/images/c02-01-1.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫1",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-2.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫2",
          catagory: "ピックアップニュース",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-3.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫3",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-4.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫4",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-5.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫5",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-6.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫6",
          catagory: "ピックアップニュース",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-7.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫7",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-8.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫8",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-9.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫9",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c03-02-1.png"),
          link: "/library/casestudy/detail",
          title: "サイバー人材需給逼迫10",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          updateDate: "2020-01-01 09:13:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text:
                "その他変更テストその他収益性向上変更テストその他収益性向上",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "Social",
              tcode: "z1_07",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テストその他収益性向上",
              tcode: "z1_09",
              children: null,
            },
          ],
        },
      ];
    } else {
      const catagoryID = parse("categoryid", option.url);
      switch (catagoryID) {
        case "1":
          list = [
            {
              cover: require("@/assets/images/c02-01-1.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫1",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:13:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text:
                    "その他変更テストその他収益性向上変更テストその他収益性向上",
                  tcode: "z1_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-2.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫2",
              catagory: "ピックアップニュース",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-02 09:13:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テスト",
                  tcode: "z1_08",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "Social",
                  tcode: "z1_07",
                  children: null,
                },
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "変更テストその他収益性向上",
                  tcode: "z1_09",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-3.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫3",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-4.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫4",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:12:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
          ];
          break;
        case "2":
          list = [
            {
              cover: require("@/assets/images/c02-01-5.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫5",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:13:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-6.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫6",
              catagory: "ピックアップニュース",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:13:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
          ];
          break;
        case "3":
          list = [
            {
              cover: require("@/assets/images/c02-01-7.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫7",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:13:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-8.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫8",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:13:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c02-01-9.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫9",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:13:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
            {
              cover: require("@/assets/images/c03-02-1.png"),
              link: "/library/casestudy/detail",
              title: "サイバー人材需給逼迫10",
              catagory: "トレンド",
              publicDate: "2020-01-01 09:12:08",
              updateDate: "2020-01-01 09:13:08",
              summary:
                "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
              tagModel: [
                {
                  itemid: "00000000-0000-0000-0000-000000000000",
                  text: "収益性向上",
                  tcode: "z2_01",
                  children: null,
                },
              ],
            },
          ];
          break;

        default:
          break;
      }
    }

    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: list.length,
        list,
      },
    };
  },
  "post|library/search": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: 25,
        list: [
          {
            id: "1",
            link: "http://www.baidu.com",
            title: "1札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2020-01-01 09:12:08",
            updateDate: "0001-01-01T00:00:00",
            catagory: "リサーチ情報",
            libraryType: "link",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text:
                  "その他変更テストその他収益性向上変更テストその他収益性向上",
                tcode: "t3",
                type: "library",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "変更テスト",
                tcode: "t2",
                type: "library",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "Social",
                tcode: "t1",
                type: "library",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "変更テストその他収益性向上",
                tcode: "z1_09",
                children: null,
              },
            ],
          },
          {
            link: require("@/assets/images/temp.pdf"),
            title: "2札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            updateDate: "2021.04.16",
            catagory: "リサーチ情報",
            libraryType: "pdf",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
          {
            link: require("@/assets/images/temp.pdf"),
            title: "3札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            updateDate: "2021.04.17",
            catagory: "リサーチ情報",
            libraryType: "pdf",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
          {
            link: require("@/assets/images/temp.pdf"),
            title: "4札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            updateDate: "2021.04.17",
            catagory: "リサーチ情報",
            libraryType: "pdf",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
          {
            link: "/library/casestudy/detail",
            title: "5札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            updateDate: "0001-01-01T00:00:00",
            catagory: "リサーチ情報",
            libraryType: "page",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
          {
            link: "/library/casestudy/detail",
            title: "6札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            libraryType: "page",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
          {
            link: "/library/casestudy/detail",
            title: "7札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            libraryType: "page",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
        ],
      },
    };
  },
  "post|library/Related": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: 4,
        list: [
          {
            cover: require("@/assets/images/c02-01-1.png"),
            link: "/research/detail",
            title: "将来のサイバー人材を生み出す観点でも",
            catagory: "トレンド",
            publicDate: "2020-01-01 09:12:08",
            summary:
              "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text:
                  "その他変更テストその他収益性向上変更テストその他収益性向上",
                tcode: "z1_01",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "変更テスト",
                tcode: "z1_08",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "Social",
                tcode: "z1_07",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "変更テストその他収益性向上",
                tcode: "z1_09",
                children: null,
              },
            ],
          },
          {
            cover: require("@/assets/images/c02-01-2.png"),
            link: "/research/detail",
            title: "サイバー人材需給逼迫2",
            catagory: "ピックアップニュース",
            publicDate: "2020-01-01 09:12:08",
            summary:
              "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "その他変更テスト",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
          {
            cover: require("@/assets/images/c02-01-3.png"),
            link: "/research/detail",
            title: "サイバー人材需給逼迫3",
            catagory: "トレンド",
            publicDate: "2020-01-01 09:12:08",
            summary:
              "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "その他変更テスト",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
          {
            cover: require("@/assets/images/c02-01-4.png"),
            link: "/research/detail",
            title: "サイバー人材需給逼迫4",
            catagory: "トレンド",
            publicDate: "2020-01-01 09:12:08",
            summary:
              "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "その他変更テスト",
                tcode: "z1_01",
                children: null,
              },
            ],
          },
        ],
      },
    };
  },
  "post|library/access": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: {},
    };
  },
  "get|library/getItemTags": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          itemid: "00000000-0000-0000-0000-000000000000",
          text: "その他変更テストその他収益性向上変更テストその他収益性向上",
          tcode: "t3",
          type: "library",
          children: null,
        },
        {
          itemid: "00000000-0000-0000-0000-000000000000",
          text: "変更テスト",
          tcode: "z1_08",
          children: null,
        },
        {
          itemid: "00000000-0000-0000-0000-000000000000",
          text: "Social",
          tcode: "z1_07",
          children: null,
        },
        {
          itemid: "00000000-0000-0000-0000-000000000000",
          text: "変更テストその他収益性向上",
          tcode: "z1_09",
          children: null,
        },
      ],
    };
  },
};
